import React from 'react';

import CircleIconButton from '../Default/CircleIconButton';
import { SideBarItems, BlockAppearanceTypes } from '../../shared';
import { ReactionAfterwards } from '../../../Game/Level/Blok/ActieReactie';
import LibraryManager from '../../../Game/Base/Library/LibraryManager';
import settings from '../../../settings';

const SideBarNavPage = ({ blokEditor, setActiveItem, activeItem, actionReactionAfterwards, defaultBlockUrl, defaultBlockHue }) => {
    let activeBlockUrl;
    let activeOtherBlockUrl;

    if (blokEditor.state1Look) {
        if (blokEditor.state1Look.type === BlockAppearanceTypes.TEXT) {
            activeBlockUrl = '/html5/assets/library/previews/text.png';
        }

        if (blokEditor.state1Look.value !== '' && blokEditor.state1Look.value != null) {
            activeBlockUrl = LibraryManager.textures.get(blokEditor.state1Look.value).get().baseTexture.imageUrl;
        }
    }

    if (blokEditor.state2Look) {
        if (blokEditor.state2Look.type === BlockAppearanceTypes.TEXT) {
            activeOtherBlockUrl = '/html5/assets/library/previews/text.png';
        }

        if (blokEditor.state2Look.value !== '' && blokEditor.state2Look.value != null) {
            activeOtherBlockUrl = LibraryManager.textures.get(blokEditor.state2Look.value).get().baseTexture.imageUrl;
        }
    }

    return (
        <div className="side-bar-row side-bar-top-nav">
            <div className="side-bar-nav-item">
                <CircleIconButton
                    active={activeItem === SideBarItems.BLOK_EDITOR}
                    onClick={() => setActiveItem(SideBarItems.BLOK_EDITOR)}
                    src={activeBlockUrl}
                    style={{ width: '3rem', height: '3rem', filter: `hue-rotate(${blokEditor.state1Look && blokEditor.state1Look.hue * -1}deg)` }}
                    iconStyle={{ width: '3rem', height: '3rem' }}
                />
            </div>
            <div className="side-bar-nav-item">
                <CircleIconButton
                    active={activeItem === SideBarItems.ACTION_REACTION}
                    onClick={() => setActiveItem(SideBarItems.ACTION_REACTION)}
                    src={`${settings.assetsPath}img/icons/obj_pijl.png`}
                    style={{ width: '3rem', height: '3rem' }}
                    iconStyle={{ width: '2rem', height: '2rem', margin: '0.5rem' }}
                />
            </div>
            {actionReactionAfterwards === ReactionAfterwards.ChangeState ? (
                <div className="side-bar-nav-item">
                    <CircleIconButton
                        active={activeItem === SideBarItems.BLOK_CHANGE_STATE}
                        onClick={() => setActiveItem(SideBarItems.BLOK_CHANGE_STATE)}
                        src={activeOtherBlockUrl || defaultBlockUrl}
                        style={{ width: '3rem', height: '3rem', filter: `hue-rotate(${(blokEditor.state2Look ? blokEditor.state2Look.hue : defaultBlockHue) * -1}deg)` }}
                        iconStyle={{ width: '3rem', height: '3rem' }}
                    />
                </div>
            ) : (
                <div className="side-bar-nav-item">
                    <div className="action-reaction-disabled" />
                </div>
            )}
        </div>
    );
};

export default SideBarNavPage;
